import React, { useState } from 'react';
import { useQuery, useMutation } from 'react-query';
import { endpoints, fetcher } from 'services';
import { message } from 'antd';
import { MSG } from 'commons/constants';

const useProjectDiagnoseDetail = (id: number, group_id: number) => {
  /* ======================================================
   * state
   * ====================================================== */
  const [diagnoseInfo, setDiagnoseInfo] = useState<ProjectDiagnoseInfoDto>();

  /* ======================================================
   * hooks
   * ====================================================== */
  const { isLoading } = useQuery(
    [endpoints.project.diagnose.info, id],
    () =>
      fetcher.project.postProjectDiagnoseInfo({id: id, group_id: group_id}),
    {
      enabled: (id > 0 || group_id > 0),
      onSuccess: (res: ProjectDiagnoseInfoResDto) => {
        switch (res.code) {
          case 200:
            setDiagnoseInfo(res.result?.info);
            break;
          case 400:
          default:
            break;
        }
      },
    },
  );

  const { mutate: projectDiagnoseInsert, isSuccess: insertSuccess } = useMutation(
    [endpoints.project.diagnose.add],
    fetcher.project.postProjectDiagnoseInsert,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_INSERT, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )

  const { mutate: projectDiagnoseUpdate, isSuccess: updateSuccess } = useMutation(
    [endpoints.project.diagnose.update],
    fetcher.project.postProjectDiagnoseUpdate,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_SAVE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )  

  const { mutate: projectDiagnoseDelete, isSuccess: deleteSuccess } = useMutation(
    [endpoints.project.diagnose.delete],
    fetcher.project.postProjectDiagnoseDelete,
    {
      onSuccess: (res) => {
        switch (res.code) {
          case 200:
            message.info(MSG.SUCCESS_DELETE, 1);
            break;
          case 500:
            alert(MSG.ERROR_ACCOUNT_CLOSE);
            break;              
          default:
            message.error(MSG.ERROR_COMMON, 1);
            break;
        }
      },
    },
  )   

  return { isLoading, diagnoseInfo, insertSuccess, updateSuccess, deleteSuccess, projectDiagnoseInsert, projectDiagnoseUpdate, projectDiagnoseDelete };
};

export default useProjectDiagnoseDetail;
